import { useEffect, useState } from 'react'

// A per-viewer preference remembered in localStorage. Storage can be missing or throw (private
// windows, blocked site data), so every access is guarded and the default always works.
export function useStoredState(key, initial) {
  const [value, setValue] = useState(() => {
    try {
      const stored = localStorage.getItem(key)
      return stored == null ? initial : JSON.parse(stored)
    } catch {
      return initial
    }
  })
  useEffect(() => {
    try {
      localStorage.setItem(key, JSON.stringify(value))
    } catch {
      // not remembered this time; nothing else depends on it
    }
  }, [key, value])
  return [value, setValue]
}
